import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const Required = (props) => {
	if (props.required) {
		return (
			<span style={{ color: 'red' }}>
				<sup>*</sup>
			</span>
		);
	}
	return null;
};

export const PaddockSize = (props) => {
	const { cols, value, handleChange, controlStyle, lock, required } = props;
	// const handleInvalid = (evt) =>{
	// 	evt.persist()
	// 	evt.target.setCustomValidity('Hectares as integer only eg. 5 or 23!');
	// }

	return (
		<Row className="inputRow">
			<Col sm={cols.lhs}>
				Paddock size [Ha]
				<Required required={required} />:
			</Col>
			<Col sm={cols.rhs}>
				<Form.Control
					id="Paddock"
					placeholder="Enter paddock size..."
					onChange={(evt) => handleChange(evt)}
					style={controlStyle}
					value={value}
					{...(lock && { disabled: true })}
				/>
			</Col>
		</Row>
	);
};
export const DisplayUnits = (props) => {
	const { cols, controlStyle, value, handleChange } = props;
	return (
		<Row className="inputRow">
			<Col sm={cols.lhs}>Display units:</Col>
			<Col sm={cols.rhs}>
				<Form.Control
					id="displayUnits"
					as="select"
					style={controlStyle}
					onChange={(evt) => handleChange(evt)}
					value={value}
				>
					<option key="m" value="m">
						Metric (kg)
					</option>
					<option key="i" value="i">
						Imperial (lb)
					</option>
				</Form.Control>
			</Col>
		</Row>
	);
};

export const SessionName = (props) => {
	// const handleValidate = (evt) =>{
	// }
	const { cols, value, handleChange, controlStyle, lock } = props;
	// const handleInvalid = (evt) =>{
	// 	evt.persist()
	// 	evt.target.setCustomValidity('Session name letters, numbers _ or - only.');
	// }
	return (
		<Row className="inputRow">
			<Col sm={cols.lhs}>
				Session name
				<Required required={true} />:
			</Col>
			<Col sm={cols.rhs}>
				<Form.Control
					id="SessionName"
					placeholder="Enter session name..."
					onChange={(evt) => handleChange(evt)}
					style={controlStyle}
					value={value}
					{...(lock && { disabled: true })}
					//isInvalid = { true }
					//isInvalid = {(props.value === undefined)}
					//pattern = {'^[a-zA-Z]+[a-zA-Z0-9_ -]+$'}
					//title = 'Session name letters, numbers _ or - only.'
					//onInvalid = { handleInvalid }
					//isInvalid = {true}
				/>
				{/* <Form.Control.Feedback type='invalid'>
					Please enter a name for the session.
				</Form.Control.Feedback> */}
			</Col>
		</Row>
	);
};

export const HeadCount = (props) => {
	const { cols, value, handleChange, controlStyle, lock } = props;
	// const handleInvalid = (evt) =>{
	// 	evt.persist()
	// 	evt.target.setCustomValidity('Numbers - integer only!');
	// }
	return (
		<Row className="inputRow">
			<Col sm={cols.lhs}>
				Number of head
				<Required required={true} />:
			</Col>
			<Col sm={cols.rhs}>
				<Form.Control
					id="Head"
					placeholder="Enter head count..."
					onChange={(evt) => handleChange(evt)}
					style={controlStyle}
					value={value}
					{...(lock && { disabled: true })}
				/>
				<Form.Control.Feedback type="invalid">
					Please enter Head count
				</Form.Control.Feedback>
			</Col>
		</Row>
	);
};

export const ShowOpenSessionsOnly = (props) => {
	const { value, setShowOpenSessionsOnly, controlStyle } = props;

	const handleChange = (evt) => {
		evt.persist();
		setShowOpenSessionsOnly(evt.target.checked);
	};
	return (
		<Form.Check
			inline
			//label = 'Show open sessions only'
			label="Hide closed sessions"
			id="show-open-sessions-only"
			onChange={handleChange}
			style={controlStyle}
			value={value}
			className="sessionListFilterCB"
		/>
	);
};

export const SessionEndDate = (props) => {
	const { cols, value, controlStyle, handleSessionEndObjChange, lock } = props;

	if (value === null || value === undefined) return null;

	return (
		<Row className="inputRow">
			<Col sm={cols.lhs}>Session end:</Col>
			<Col sm={cols.rhs}>
				<DatePicker
					id="sessionEndObj"
					className={'datepickerxx form-control'}
					//className = { 'datepicker' }
					dateFormat={'dd MMM yyyy HH:mm'}
					selected={value || new Date()}
					showTimeSelect
					todayButton={'Now'}
					timeIntervals={15}
					scrollableYearDropdown={true}
					showYearDropdown={true}
					onChange={(dateObj) => handleSessionEndObjChange(dateObj)}
					style={controlStyle}
					{...(lock && { disabled: true })}
				/>
			</Col>
		</Row>
	);
};
